// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1XBK1","header":"ReportDetails_header__8uOHQ","title":"ReportDetails_title__1eSRD","left":"ReportDetails_left__3rgji"};